import styled from "styled-components";

import { boxShadow } from "core/SiteHeader/constants";
import colors from "core/colors";

export const Wrapper = styled.div`
    background-color: ${({ isHeroSearchV2 }) =>
        isHeroSearchV2 ? colors.snow : colors.midnight};
    ${({ isHeroSearchV2 }) => isHeroSearchV2 && `box-shadow: ${boxShadow}`};
    padding: 1.5625rem 1.875rem 1.875rem 1.875rem;
    display: inline-block;

    ${({ isHeroSearchV2 }) =>
        isHeroSearchV2 &&
        `
            p {
                color: ${colors.midnight};
            }
            
            &.scrolledDown {
                background-color: ${colors.midnight};

                p {
                    color: ${colors.snow};
                }
            }

            &.scrolledUp {
                background-color: ${colors.snow};

                p {
                    color: ${colors.midnight};
                }
            }
        `};
`;
